(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-image-switch"] && !Shopify.designMode) return;
  try {
    

    const blocks = document.querySelectorAll('.hero-image--content_switch .switch-container');
    const parentID = blocks[0].parentElement.getAttribute('data-parent');
    blocks.forEach(block => {
        block.addEventListener('click', function () {
            const blockID = block.getAttribute('data-section-id');
            const elems = document.querySelectorAll('#hero-image[data-parent="' + parentID + '"]');

            blocks.forEach(block => {
                block.removeAttribute('aria-active');
                document.querySelector('.hero-image--switch[data-section="' + block.getAttribute('data-section-id') + '"]').removeAttribute('aria-active');
            })
            elems.forEach(section => {
                var sectionID = section.getAttribute('data-section')
                if (sectionID == blockID) {
                    var child = document.querySelector('.hero-image--switch[data-section="' + blockID + '"]');
                    console.log(section);
                    child.setAttribute('aria-active', '');
                    child.style.display = 'block!important';
                  
                    block.setAttribute('aria-active', '');
                    
                    section.style.setProperty("display", "grid", "important")
                    section.style.height = 'auto';
                    section.style.visibility = 'visible';
                } else {
                    section.style.display = 'none';
                    section.style.height = '0px';
                    section.style.visibility = 'hidden';
                }
            });
        });
    });
    

  } catch(e) { console.error(e); }
})();
})();
